import { X } from 'lucide-react';
import type { CSSProperties, ReactElement } from 'react';

interface StoreActiveFilterChipProps {
  readonly label: string;
  /** 색상 칩만 — 글자 앞 대표색 점. */
  readonly swatchStyle?: CSSProperties;
  readonly onRemove: () => void;
}

/** 걸린 조건 칩 한 개 — 얇은 테두리 알약 전체가 해제 버튼이다(이름: "{label} 필터 해제"). */
export const StoreActiveFilterChip = ({
  label,
  swatchStyle,
  onRemove,
}: StoreActiveFilterChipProps): ReactElement => (
  <li>
    <button
      type="button"
      aria-label={`${label} 필터 해제`}
      onClick={onRemove}
      className="inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-full border border-foreground/20 pr-2.5 pl-3 text-[13px] whitespace-nowrap transition-colors hover:border-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {swatchStyle !== undefined ? (
        <span
          aria-hidden
          style={swatchStyle}
          className="size-3 shrink-0 rounded-full border border-foreground/20"
        />
      ) : null}
      {label}
      <X aria-hidden strokeWidth={1.75} className="size-3.5 text-muted-foreground" />
    </button>
  </li>
);
